const doc = [({"en":({"js":({"admin":({"plans":({"show":({"show_plan":"Show plan: %{name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;